
import { Component, Vue, Watch } from 'vue-property-decorator'
import { Route } from 'vue-router'
import { useRouter } from 'vue-router';
import { Form as ElForm } from 'element-ui'
import { draw } from '../../utils/drawVerifyNumber'
// import SetorgVue from './Setorg.vue'
import { usernameValidator, passwordValidator, checkCodeValidator } from '../../utils/validator'
import api from '../../api'
import { UserModule } from '../../store/modules/user'
import BaseClass from '../../virtual-class/baseClass'
import SetorgVue from './Setorg.vue'
import { log } from 'console';
@Component({
  components: {
    SetorgVue,
  },
})
export default class Login extends BaseClass {
  private loginForm = {
    username: '',
    password: '',
    code: '',
    codeValue: '',
  }
  private seletShow = false
  private loginRules = {
    username: [{ required: true, trigger: 'blur', validator: usernameValidator }],
    password: [{ required: true, trigger: 'blur', validator: passwordValidator }],
    code: [{ required: true, trigger: 'blur', validator: checkCodeValidator(() => this.loginForm.codeValue) }],
  }
  private loading = false
  private pwdType = 'password'
  private redirect: string | undefined = undefined

  @Watch('$route', { immediate: true })
  private OnRouteChange(route: Route) {
    // TODO: remove the "as string" hack after v4 release for vue-router
    // See https://github.com/vuejs/vue-router/pull/2050 for details
    this.redirect = route.query && (route.query.redirect as string)
  }
  public mounted() {
    this.updateCode()
  }

  private updateCode() {
    this.loginForm.codeValue = draw('#codeCanvas')
  }
  private showPwd() {
    if (this.pwdType === 'password') {
      this.pwdType = ''
    } else {
      this.pwdType = 'password'
    }
  }
  private handleClose() {
    this.seletShow = false
  }

  private handleLogin() {
    //清除登录账户空格
    // this.loginForm.username = this.loginForm.username.trim()
    // this.loginForm.password = this.loginForm.password.trim()  
    (this.$refs.loginForm as ElForm).validate((valid: boolean) => {
      if (valid) {
        this.loading = true
        api.getPubKey({ name: this.loginForm.username }).then((data: any) => {
          UserModule.setPubKey(data.rsaPubKey || '')
          const random8DigitNumber = Math.floor(10000000 + Math.random() * 90000000);
          UserModule.setStaticKey(random8DigitNumber.toString())
          UserModule.Login({
            name: this.loginForm.username,
            pwd: this.useEncryption(this.loginForm.password),
            key: this.useEncryption(UserModule.staticKey),
          }).then((res) => {
                  //  localStorage.setItem('psw', pwd)
            localStorage.setItem('orgId', res.org.orgId)
            // console.log(res)
            // if (res.user.role === 0 || res.user.role === 4) {
            //   this.seletShow = true

            // } else {
              this.$message.success('登录成功')
              this.$router.push({ name: 'Home' })
            // }
          }).catch(() => {})
        }).finally(() => { this.loading = false })
      }
    })
  }

  created(){
     let code=this.$route.query.code
     console.log(code);
     if(code){
      let data={
        code:code,
      }

        UserModule.codeLogin(data).then((res) => {
            // console.log(res)
            // if (res.user.role === 0 || res.user.role === 4) {
            //   this.seletShow = true

            // } else {
              this.$message.success('登录成功')
              this.$router.push({ name: 'Home' })
            // }
          }).catch(() => {})
   
        

     }
     
  }
}
